// 15个业务模块的菜单、表格列与表单配置(配置驱动,新增模块只需在此加一份配置)
//
// key        : 同时作为后端接口路径(/api/{key}/page 等)与前端路由标识,必须与后端 Controller 的 @RequestMapping 一致
// searchProp : 后端分页查询接口的模糊匹配参数名(各模块专属,取自对应的 XxxQueryDTO)
// columns[].type   : text 文本 | number 数字 | amount 金额(元) | percent 百分比 | date 日期 | datetime 日期时间 | tag 状态标签
// columns[].required: 表单必填项(与后端 DTO 的 @NotBlank/@NotNull 校验保持一致)
// columns[].options : tag 字段的可选项(下拉可选、也可手工输入)
// adminOnly  : 仅管理员可见;custom: 使用专属页面组件(不走通用 ModuleView)
export const modules = [
  {
    key: 'farm',
    path: '/farm',
    name: '养殖场模块',
    searchProp: 'houseNo',
    columns: [
      { prop: 'houseNo', label: '鸡舍编号', width: 100, required: true },
      { prop: 'area', label: '鸡舍面积(㎡)', type: 'number' },
      { prop: 'chickenCount', label: '饲养鸡数(只)', type: 'number' },
      { prop: 'cleanStatus', label: '清洁情况', type: 'tag', options: ['优秀', '良好', '一般', '差'] },
      { prop: 'temperature', label: '温度(℃)', type: 'number' },
      { prop: 'humidity', label: '湿度(%)', type: 'number' },
      { prop: 'ventilation', label: '通风情况', type: 'tag', options: ['正常', '增强', '偏弱', '不足'] },
      { prop: 'lighting', label: '灯光情况', type: 'tag', options: ['正常', '增强', '偏弱'] },
      { prop: 'feedUse', label: '饲料使用情况', minWidth: 160 },
      { prop: 'medicineUse', label: '药品使用情况', minWidth: 140 }
    ]
  },
  {
    key: 'feed',
    path: '/feed',
    name: '饲料管理',
    searchProp: 'feedName',
    columns: [
      { prop: 'feedName', label: '饲料名称', width: 140, required: true },
      { prop: 'spec', label: '饲料规格' },
      { prop: 'factory', label: '饲料厂家', width: 130 },
      { prop: 'price', label: '饲料价格(元)', type: 'amount' },
      // 后端字段为 usageQty(SQL 中 usage 为保留字,列名改为 usage_qty)
      { prop: 'usageQty', label: '饲料用量' },
      { prop: 'stock', label: '饲料库存(kg)', type: 'number' },
      { prop: 'inTime', label: '入库时间', type: 'date' },
      { prop: 'expireTime', label: '过期时间', type: 'date' },
      { prop: 'outTime', label: '出库时间', type: 'date' },
      { prop: 'remark', label: '备注', minWidth: 140 }
    ]
  },
  {
    key: 'medicine',
    path: '/medicine',
    name: '药品管理',
    searchProp: 'medicineName',
    columns: [
      { prop: 'medicineName', label: '药品名称', width: 160, required: true },
      { prop: 'spec', label: '药品规格' },
      { prop: 'factory', label: '药品厂家', width: 130 },
      { prop: 'price', label: '药品价格(元)', type: 'amount' },
      { prop: 'usageQty', label: '药品用量', minWidth: 130 },
      { prop: 'stock', label: '药品库存', type: 'number' },
      { prop: 'inTime', label: '入库时间', type: 'date' },
      { prop: 'expireTime', label: '过期时间', type: 'date' },
      { prop: 'outTime', label: '出库时间', type: 'date' },
      { prop: 'remark', label: '备注', minWidth: 140 }
    ]
  },
  {
    key: 'purchase',
    path: '/purchase',
    name: '采购管理',
    searchProp: 'orderNo',
    columns: [
      { prop: 'orderNo', label: '采购单编号', width: 150, required: true },
      { prop: 'purchaseDate', label: '采购日期', type: 'date' },
      { prop: 'supplier', label: '供应商名称', width: 130 },
      { prop: 'goods', label: '采购物品' },
      { prop: 'quantity', label: '采购数量', type: 'number' },
      { prop: 'amount', label: '采购金额(元)', type: 'amount' },
      { prop: 'handler', label: '经手人' },
      { prop: 'remark', label: '备注', minWidth: 150 }
    ]
  },
  {
    key: 'production',
    path: '/production',
    name: '生产管理',
    searchProp: 'hatchType',
    columns: [
      { prop: 'hatchDate', label: '孵化日期', type: 'date', required: true },
      { prop: 'hatchType', label: '孵化种类' },
      { prop: 'hatchCount', label: '孵化数量(只)', type: 'number' },
      { prop: 'successRate', label: '孵化成功率', type: 'percent' },
      { prop: 'health', label: '健康情况', type: 'tag', options: ['优秀', '良好', '一般', '差'] },
      { prop: 'saleStatus', label: '销售情况', type: 'tag', options: ['待售', '部分销售', '已售'] },
      { prop: 'feeding', label: '喂养情况', type: 'tag', options: ['正常', '略差', '差'] },
      { prop: 'immune', label: '免疫情况', type: 'tag', options: ['已免疫', '待免疫'] },
      { prop: 'disease', label: '疾病情况', minWidth: 130 },
      { prop: 'handleWay', label: '处理方式', minWidth: 130 }
    ]
  },
  {
    key: 'sales',
    path: '/sales',
    name: '销售管理',
    searchProp: 'orderNo',
    columns: [
      { prop: 'orderNo', label: '销售单编号', width: 150, required: true },
      { prop: 'saleDate', label: '销售日期', type: 'date' },
      { prop: 'customer', label: '客户名称', width: 140 },
      { prop: 'goods', label: '销售物品' },
      { prop: 'quantity', label: '销售数量', type: 'number' },
      { prop: 'amount', label: '销售金额(元)', type: 'amount' },
      { prop: 'handler', label: '经手人' },
      { prop: 'remark', label: '备注', minWidth: 150 }
    ]
  },
  {
    key: 'warehouse',
    path: '/warehouse',
    name: '进出库管理',
    searchProp: 'goodsName',
    columns: [
      { prop: 'goodsName', label: '品名', width: 150, required: true },
      { prop: 'quantity', label: '数量', type: 'number' },
      { prop: 'ioFlag', label: '进/出库标志', type: 'tag', options: ['入库', '出库'] },
      { prop: 'ioTime', label: '进/出库时间', type: 'datetime' },
      { prop: 'handler', label: '经手人' },
      { prop: 'remark', label: '备注', minWidth: 180 }
    ]
  },
  {
    key: 'check',
    path: '/check',
    name: '日常检查模块',
    searchProp: 'checkItem',
    columns: [
      { prop: 'checkTime', label: '检查时间', type: 'datetime', required: true },
      { prop: 'checkItem', label: '检查项目', width: 150 },
      { prop: 'checkResult', label: '检查结果', type: 'tag', options: ['正常', '异常'] },
      { prop: 'handleStatus', label: '处理情况', minWidth: 200 },
      { prop: 'recorder', label: '记录人' }
    ]
  },
  {
    key: 'vaccine',
    path: '/vaccine',
    name: '疫苗管理',
    searchProp: 'vaccineName',
    columns: [
      { prop: 'vaccineName', label: '疫苗名称', width: 150, required: true },
      { prop: 'spec', label: '疫苗规格' },
      { prop: 'validDate', label: '有效期', type: 'date' },
      { prop: 'factory', label: '厂家', width: 120 },
      { prop: 'dosage', label: '剂量' },
      { prop: 'injectTime', label: '注射时间', type: 'datetime' },
      { prop: 'injectPart', label: '注射部位' },
      { prop: 'immuneStatus', label: '免疫情况', type: 'tag', options: ['良好', '一般', '差'] },
      { prop: 'handler', label: '经手人' }
    ]
  },
  {
    key: 'egg',
    path: '/egg',
    name: '鸡蛋管理',
    searchProp: 'eggNo',
    columns: [
      { prop: 'eggNo', label: '鸡蛋编号', width: 140, required: true },
      { prop: 'layTime', label: '下蛋时间', type: 'datetime' },
      { prop: 'houseNo', label: '鸡舍编号', width: 100 },
      { prop: 'storeTime', label: '储存时间', type: 'datetime' },
      { prop: 'saleStatus', label: '销售情况', type: 'tag', options: ['待售', '已售'] },
      { prop: 'qualityCheck', label: '质量检测', type: 'tag', options: ['合格', '待检', '不合格'] },
      { prop: 'handler', label: '经手人' }
    ]
  },
  {
    key: 'breed',
    path: '/breed',
    name: '种鸡购买模块',
    searchProp: 'orderNo',
    columns: [
      { prop: 'orderNo', label: '购买单号', width: 150, required: true },
      { prop: 'buyDate', label: '购买日期', type: 'date' },
      { prop: 'breedType', label: '种鸡种类', width: 150 },
      { prop: 'quantity', label: '数量(只)', type: 'number' },
      { prop: 'price', label: '售价(元)', type: 'amount' },
      { prop: 'supplier', label: '供应商', width: 130 },
      { prop: 'handler', label: '经手人' },
      { prop: 'remark', label: '备注', minWidth: 150 }
    ]
  },
  {
    key: 'clean',
    path: '/clean',
    name: '鸡舍清洁模块',
    searchProp: 'houseNo',
    columns: [
      { prop: 'cleanTime', label: '清洁时间', type: 'datetime', required: true },
      { prop: 'houseNo', label: '鸡舍编号', width: 110 },
      { prop: 'cleanStatus', label: '清洁情况', type: 'tag', options: ['优秀', '良好', '一般', '差'] },
      { prop: 'cleaner', label: '清洁人员' },
      { prop: 'remark', label: '备注', minWidth: 200 }
    ]
  },
  {
    key: 'slaughter',
    path: '/slaughter',
    name: '屠宰管理',
    // 后端屠宰模块按屠宰人员模糊匹配(日期作为查询条件需额外支持,当前表单仍可编辑)
    searchProp: 'worker',
    columns: [
      // 后端字段为 slaughterDate(避免与 SQL 保留字 date 冲突)
      { prop: 'slaughterDate', label: '屠宰日期', type: 'date', required: true },
      { prop: 'slaughterCount', label: '屠宰数量(只)', type: 'number' },
      { prop: 'productCount', label: '成品数量(kg)', type: 'number' },
      { prop: 'wasteCount', label: '产生废品数量(kg)', type: 'number' },
      { prop: 'worker', label: '屠宰人员' },
      { prop: 'handler', label: '经手人' }
    ]
  },
  {
    key: 'cost',
    path: '/cost',
    name: '成本管理',
    // 成本表未设计日期列,统计周期存放在 remark,故按备注模糊匹配
    searchProp: 'remark',
    columns: [
      { prop: 'feedCost', label: '饲料成本(元)', type: 'amount' },
      { prop: 'medicineCost', label: '药品成本(元)', type: 'amount' },
      { prop: 'transportCost', label: '运输成本(元)', type: 'amount' },
      { prop: 'laborCost', label: '人工成本(元)', type: 'amount' },
      { prop: 'deviceCost', label: '设备折旧(元)', type: 'amount' },
      { prop: 'otherCost', label: '杂项成本(元)', type: 'amount' },
      { prop: 'totalCost', label: '总成本(元)', type: 'amount', required: true },
      { prop: 'remark', label: '统计周期', minWidth: 150 }
    ]
  },
  {
    key: 'report',
    path: '/report',
    name: '统计报表模块',
    isGroup: true,
    children: [
      { key: 'salesReport', path: '/report/sales', name: '销售报表' },
      { key: 'stockReport', path: '/report/stock', name: '库存报表' },
      { key: 'ioReport', path: '/report/io', name: '进出库报表' },
      { key: 'financeReport', path: '/report/finance', name: '财务报表' },
      { key: 'diseaseReport', path: '/report/disease', name: '疾病报表' },
      { key: 'productionReport', path: '/report/production', name: '生产报表' },
      { key: 'businessReport', path: '/report/business', name: '经营报表' },
      { key: 'healthReport', path: '/report/health', name: '健康报表' },
      { key: 'yieldReport', path: '/report/yield', name: '亩产报表' },
      { key: 'marketingReport', path: '/report/marketing', name: '营销报表' }
    ]
  },
  {
    key: 'user',
    path: '/user',
    name: '用户管理',
    adminOnly: true,
    custom: true,
    searchProp: 'username',
    columns: [
      { prop: 'username', label: '用户名', width: 140 },
      { prop: 'email', label: '邮箱', minWidth: 180 },
      { prop: 'userType', label: '用户类型', type: 'tag', width: 110 },
      { prop: 'loginCount', label: '登录次数', type: 'number', width: 100 },
      { prop: 'lastLoginTime', label: '上次登录时间', type: 'datetime', minWidth: 160 },
      { prop: 'createTime', label: '创建时间', type: 'datetime', minWidth: 160 },
      { prop: 'updateTime', label: '更新时间', type: 'datetime', minWidth: 160 }
    ]
  }
]

// 根据模块 key 查找配置
export function findModule(key) {
  return modules.find(m => m.key === key)
}

// 当前用户可见的模块:普通用户不展示「用户管理」等仅管理员菜单
export function filterModules(admin) {
  return modules.filter(m => !m.adminOnly || admin)
}
